import { Card, CardBody, CardHeader, CardHeading } from "@dgs/core";
import { FC } from "react";
import { useTranslation } from "react-i18next";
import styled from "styled-components";
import { ContactUpdateInquiryDetailsResource } from "../../shared/types/contactUpdateInquiry";
import { ValueView } from "./ValueView";

const StyledCardBody = styled(CardBody)`
	display: grid;
	grid-template-columns: 1fr 1fr;
	gap: ${({ theme }) => theme.spacing(4)};
`;

interface Props {
	contactUpdateInquiry: ContactUpdateInquiryDetailsResource;
}

const calculate = (count: number, totalCount: number) => {
	return `${count} (${Math.round((count / totalCount) * 100)}%)`;
};

export const ContactUpdateInquiryPerformance: FC<Props> = ({ contactUpdateInquiry }) => {
	const { t } = useTranslation();

	return (
		<Card>
			<CardHeader>
				<CardHeading>{t("Analytics")}</CardHeading>
			</CardHeader>
			<StyledCardBody>
				<ValueView label={t("All contacts")} value={contactUpdateInquiry.contactCount} />
				<ValueView
					label={t("Feedbacks")}
					value={calculate(contactUpdateInquiry.feedbackCount, contactUpdateInquiry.contactCount)}
				/>
				<ValueView
					label={t("Update inquiries")}
					value={calculate(contactUpdateInquiry.updateCount, contactUpdateInquiry.contactCount)}
				/>
				<ValueView
					label={t("Deletion requests")}
					value={calculate(contactUpdateInquiry.deleteCount, contactUpdateInquiry.contactCount)}
				/>
			</StyledCardBody>
		</Card>
	);
};
